import React from 'react';
const COMMENT_TYPE = [{
  id: 'all',
  text: '全部'
},{
  id: 'pic',
  text: '有图'
},{
  id: 'good',
  text: '好评'
},{
  id: 'general',
  text: '中评'
},{
  id: 'bad',
  text: '差评'
}];

export default function CommentType(props) {
  let { acitveType, count, handleChangeCommentType} = props;
  return (
    <div className="comment-type-list">
      {
        COMMENT_TYPE.map((item, index) =>{
          let _count = count[item.id];
          if(!_count) return null;
          return <Item
            key={index}
            index={index}
            item={item}
            count={(item && item.id !== 'all') ? count[item.id] : null}
            isAcitve={acitveType === item.id}
            handleClickType={handleChangeCommentType} />;
        })
      }
    </div>
  );
}

function Item(props){
  let { item, handleClickType, isAcitve, count } = props;
  let itemClass = isAcitve ? 'comment-type-item active' : 'comment-type-item';

  return (
    <div className={itemClass} onClick={()=>{
      handleClickType(item.id);
    }}>
      { item.text }
      { count ? <span className="count">（{count}）</span> : null }
    </div>
  );
}







// WEBPACK FOOTER //
// ./src/components/Poi2/Comment/CommentType.js